import React from 'react'
import logo from '../logo.png'
import './Header.css'

const LockIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
    aria-hidden="true">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
  </svg>
)

const ShieldIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
    aria-hidden="true">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
  </svg>
)

const Header = () => {
  return (
    <header className="portal-header" role="banner">
      <div className="portal-header__inner">

        {/* Logo + Brand */}
        <a
          href="https://getnet.live"
          className="portal-header__brand"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="GetNet Broadband — back to main site"
        >
          <img src={logo} alt="GetNet logo" className="portal-header__logo-img" />
        </a>

        {/* Security badges */}
        <div className="portal-header__badges" aria-label="Security information">
          <span className="portal-header__badge portal-header__badge--ssl">
            <LockIcon />
            SSL Secured
          </span>
          <span className="portal-header__badge portal-header__badge--upi">
            <ShieldIcon />
            UPI Payment
          </span>
        </div>

      </div>

      {/* Decorative gradient line */}
      <div className="portal-header__line" aria-hidden="true" />
    </header>
  )
}

export default Header
